<template>
    <div>
      <app-gridview
        v-bind:parentData="{
          tabHeaders: this.dataHeader,
          tabItems: this.dataItems,
          pageTitle: this.pageTitle,
          search: this.search,
          isAdvanceEdit: true,
          isDelete: true,
        }"
        v-on:AdvanceEditItem="advanceEditItemHandler($event)"
        v-on:EditItem="editItemHandler($event)"
        v-on:DeleteItem="deleteItemHandler($event)"
        v-on:NewPressed="newRecordHandler"
      ></app-gridview>
    </div>
  </template>
<script>
import moment from 'moment';
import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('performancemanagement.kpisettingexerciselist'),
      dataHeader: [

        { text: '', value: "action", sortable: false, width: "150px" },
        { text: this.$t('performancemanagement.exercise'), value: "kpiexercode", sortable: false, width: "50px" },
        { text: this.$t('pmreviewexercise.exercisedesc'), value: "kpiexerdesc", width: "120px" },
        { text: this.$t('columns.startdate'), value: "startdate", width: "200px" },
        { text: this.$t('columns.enddate'), value: "enddate", width: "200px" },
        { text: this.$t('columns.status'), value: "kpiexerstatus", width: "200px" },
        { text: this.$t('columns.recordsinsharp'), value: "records", width: "200px" },
        { text: this.$t('columns.pendingrecords'), value: "pending", width: "200px" },
        { text: this.$t('columns.openrecords'), value: "open", width: "200px" },
        { text: this.$t('columns.lockedrecords'), value: "locked", width: "200px" },

        
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
        search: this.$route.params.search,
    };
  },

  methods: {
    getKpiExerciseHandler() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/kpiexercise/all"})
        .then(function (res) {

          vm.dataItems = res.data.rec;

            for (let i = 0; i < vm.dataItems.length; i++) {
            if (vm.dataItems[i].startdate) {
                vm.dataItems[i].startdate = moment(vm.dataItems[i].startdate).format('YYYY-MM-DD');
            }

            if (vm.dataItems[i].enddate) {
                vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format('YYYY-MM-DD');
            }
          }
          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    advanceEditItemHandler(item) {
      this.$router.push({ name: "kpisettingstaff", params: { id: item.id } });
    },

    editItemHandler(item) {
      this.$router.push({ name: "kpisettingedit", params: { id: item.id } });
    },

    deleteItemHandler(item){
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
          return false;
      }

      if (confirm(this.$t('performancemanagement.deletekpiexercise'))) {
          this.$store.dispatch('delete', {
              url: "/kpiexercise/" + item.id + '/' + this.$store.getters.userId
          })
          .then((res) => {
          if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
          } else {
              window.location.reload();
          }
          })
          .catch((err) => {
              vm.isErr = !vm.isErr;
              vm.errMsg = err;
          });
      }
    },

    newRecordHandler() {
      this.$router.push({ name: "kpisettingnew" });
    },
  },
  mounted() {
    this.getKpiExerciseHandler();
  },
};
</script>